





















import { Component, Prop, Vue } from "vue-property-decorator";
import { getEventTarget } from "@/utils/dom";
import { InputConstraints } from "@/types";

let nextInputId = 1;

@Component
export default class InputGroup extends Vue {
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ required: true }) name!: string;
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) constraints!: InputConstraints;

  showError = false;
  error = "";
  inputId = "";

  mounted(): void {
    this.inputId = "sp-checkbox-group-input-" + nextInputId;
    nextInputId += 1;
  }

  onInput(event: Event): void {
    this.$emit("input", getEventTarget(event, HTMLInputElement).checked);
    this.updateErrorState();
  }

  onChange(event: Event): void {
    this.$emit("change", getEventTarget(event, HTMLInputElement).checked);
    this.updateErrorState();
  }

  onFocus(event: Event): void {
    this.$emit("focus", getEventTarget(event, HTMLInputElement).value);
  }

  onBlur(event: Event): void {
    this.$emit("blur", getEventTarget(event, HTMLInputElement).value);
  }

  onInvalid(event: Event): void {
    this.$emit("invalid", getEventTarget(event, HTMLInputElement).value);
    this.showError = true; // show validation errors after submit
    this.updateErrorState();
  }

  updateErrorState(): void {
    this.error = this.showError ? this.$refs.input.validationMessage : "";
  }
}
